import React, {useEffect} from "react";
import {BrowserRouter} from "~/apps/core/BrowserRouter";
import {Redirect, Route, Switch} from "react-router-dom";
import {IndexPage} from "~/apps/packages/auto-shipment-orders/components/IndexPage";
import {DetailPage} from "~/apps/packages/auto-shipment-orders/components/DetailPage";
import {CreatePage} from "~/apps/packages/auto-shipment-orders/components/CreatePage";
import {AccessRequired} from "~/apps/core/ui/AccessRequired";
import {useApolloClient} from "@apollo/client";

const AutoShipmentOrdersApp = () => {
    const client = useApolloClient();
    // Invalidate apollo cache when leave service
    useEffect(() => () => {
        client.cache.evict({id: "ROOT_QUERY", fieldName: "autoShipmentOrders"});
    }, []);
    return (
        <AccessRequired title="Наряды на авто">
            <BrowserRouter basename="/apps/auto-shipment-orders">
                <Switch>
                    <Route path="/new">
                        <CreatePage />
                    </Route>
                    <Route path="/:id" exact={true}>
                        <DetailPage />
                    </Route>
                    <Route path="/" exact={true}>
                        <IndexPage />
                    </Route>
                    <Route path="*">
                        <Redirect to="/"/>
                    </Route>
                </Switch>
            </BrowserRouter>
        </AccessRequired>
    );
}

export default AutoShipmentOrdersApp;
